function Route() {
  return null;
}

export { Route };
